import { render, staticRenderFns } from "./searchcollect.vue?vue&type=template&id=737097be&scoped=true"
import script from "./searchcollect.vue?vue&type=script&lang=js"
export * from "./searchcollect.vue?vue&type=script&lang=js"
import style0 from "./searchcollect.vue?vue&type=style&index=0&id=737097be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737097be",
  null
  
)

export default component.exports